import React, { forwardRef, useRef } from "react"
import calendar_icon from "../../assets/images/calendar_icon_small.svg"
import styles from "./InputTag.module.scss"

interface InputTagProps extends React.InputHTMLAttributes<HTMLInputElement> {
    small?: boolean
    inputstyle?: React.CSSProperties
    start?: string
    end?: string
    error?: boolean
    showError?: boolean
    height?: string
    maxCharacter?: number
    endClick?: () => void
    errorText?: string
    className?: string
    containerClass?: string
    useCustomDate?: boolean
}

const InputTag = forwardRef((props: InputTagProps, ref) => {
    const inputRef = useRef<HTMLInputElement | null>(null)

    // Function to trigger date picker when calendar icon is clicked
    const handleCalendarIconClick = () => {
        if (inputRef.current && inputRef.current.type === "date") {
            ;(inputRef.current as any).showPicker()
        }
    }

    const handleDateToggle = () => {
        if (inputRef.current) {
            inputRef.current.type = "date"
            // Some mobile browsers haven't finished applying the type="date" switch yet
            // when showPicker() runs in the same tick, so the very first toggle silently
            // no-ops. Deferring to the next frame lets the browser catch up first.
            requestAnimationFrame(handleCalendarIconClick)
        }
    }

    return (
        <>
            <div
                className={`${props.small ? styles.input_tag_small_wrapper : styles.input_tag_wrapper} ${props.containerClass ? props.containerClass : ""}`}
                style={props.inputstyle}
            >
                {props.start && <img src={props.start} className={styles.start_img} alt="startImg" />}
                <input
                    ref={props.type === "date" ? inputRef : (ref as React.RefObject<HTMLInputElement>)}
                    style={{ height: props.height ? props.height : "", cursor: props?.disabled ? "not-allowed" : "" }}
                    maxLength={props.maxCharacter}
                    {...props}
                    onFocus={props?.type === "date" && props?.useCustomDate ? handleDateToggle : () => {}}
                    // onBlur={props?.type === "date" ? handleDateRevert : () => {}}
                    type={props?.type === "date" && props?.useCustomDate ? "text" : props?.type}
                    className={`${props.start ? styles.have_start_img : ""} ${props.error && props.showError ? `${styles.error} ${styles.input_tag} ${props.className}` : `${styles.input_tag} ${props.className}`}
            ${props?.type === "date" && props?.useCustomDate ? styles.hide_cal : ""} 
            `}
                />
                {props.type === "date" && props?.useCustomDate && (
                    <img
                        src={calendar_icon}
                        className={styles.calendar_icon}
                        alt="endImg"
                        onClick={() => (!props?.disabled ? handleDateToggle() : {})}
                    />
                )}
                {props.end && <img src={props.end} className={styles.end_img} alt="endImg" onClick={props.endClick} />}
            </div>
            {props.error && props.showError && props.errorText !== undefined && (
                <div className={styles.error_text}>{props.errorText}</div>
            )}
        </>
    )
})

export default InputTag
